class BackgroundSyncService {
  constructor() {
    this.isRegistered = false;
    this.init();
  }

  async init() {
    if ('serviceWorker' in navigator && 'sync' in window.ServiceWorkerRegistration.prototype) {
      try {
        const registration = await navigator.serviceWorker.ready;
        this.registration = registration;
        this.isRegistered = true;
        this.setupMessageListener();
      } catch (error) {
        console.warn('Background sync not available');
      }
    }
  }

  setupMessageListener() {
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data.type === 'SYNC_COMPLETE') {
        this.showSyncNotification(event.data.payload);
      }
    });
  }

  async registerBackgroundSync(tag = 'data-sync') {
    if (!this.isRegistered) return false;
    
    try {
      await this.registration.sync.register(tag);
      return true;
    } catch (error) {
      return false;
    }
  }

  async showSyncNotification(data) {
    if (!('Notification' in window)) return;

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return;

    const options = {
      body: `${data.syncedCount} submissions synced successfully`,
      icon: '/icons/icon-192x192.png',
      badge: '/icons/badge-72x72.png',
      tag: 'sina-sync',
      requireInteraction: false,
      silent: false,
      data: { url: '/sync' }
    };

    if ('serviceWorker' in navigator) {
      const registration = await navigator.serviceWorker.ready;
      registration.showNotification('Terriqon - Data Synced', options);
    } else {
      new Notification('Terriqon - Data Synced', options);
    }
  }

  async requestNotificationPermission() {
    if (!('Notification' in window)) return false;
    
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }
}

export const backgroundSyncService = new BackgroundSyncService();